export default __webpack_public_path__ + "static/media/8.a3e5205a.jpg";